/* unplugin-vue-components disabled */import script from "./my-org-list-view.vue?vue&type=script&setup=true&lang=js"
export * from "./my-org-list-view.vue?vue&type=script&setup=true&lang=js"

import "./my-org-list-view.vue?vue&type=style&index=0&id=24e4e5e3&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e4e5e3"]])

export default __exports__